import React, { useState, useEffect, useRef } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import SearchIcon from '@mui/icons-material/Search'
import { AxiosError } from 'axios'
import {
  Button,
  CheckBox,
  Col,
  Form,
  Grid,
  Input,
  InputFile,
  Picker,
  Row,
  Span,
  TextArea,
  ChipInput,
  AutoCompleteInput,
  CurrencyInput,
  UnidadeGestoraFields
} from 'components'
import SimpleCollapse from 'components/Collapse/SimpleCollapse'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import { useAuth, useLoading, useToggle, useModal, useEnvironment } from 'hooks'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { ContractNGTServices } from 'services/NGT/Contract'
import { SupplierRegistrationServices } from 'services/NGT/SupplierRegistration'
import { IGetCsnUserByResponse } from 'services/Supplier/Users'
import { COLORS, FONTS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'
import { convertBase64, preventDefaultOnEnter } from 'utils/functions'
import * as yup from 'yup'
import { Toast } from 'components/ChipInput'
import FakeAttachedFiles from '../ViewContract/components/FakeAttachedFiles'

interface FormProps {
  idUnidadeGestora: number
  contrato: any
  handleCloseModal: Function
  tipoCre: any
  cdHierarquiaProd?: string
  unidadeComprador?: string
  selectedComprador?: IGetCsnUserByResponse
  // eslint-disable-next-line no-unused-vars
  enviarEmailHandle: (idContrato: number) => void
  dtVigenciaFim?: Date
  dtVigenciaInicio?: Date
  dtVigenciaRealFim?: Date
  dtVigenciaRealInicio?: Date
}

export const SubContract: React.FC<FormProps> = ({
  idUnidadeGestora,
  contrato,
  handleCloseModal,
  cdHierarquiaProd,
  dtVigenciaFim,
  dtVigenciaInicio,
  dtVigenciaRealFim,
  dtVigenciaRealInicio,
  unidadeComprador,
  selectedComprador,
  tipoCre
}) => {
  console.log('🚀 ~ tipoCre:', tipoCre)


  //Criando os hooks para o Toast

  const [showToast, setShowToast] = useState(false)
  const [toastMessage, setToastMessage] = useState('')


  const dateNow = new Date()
  const { setLoading, setMsgErro } = useLoading()
  const { user } = useAuth()

  const schema = yup.object({
    ObjetoDoContrato: yup.string().required('Campo obrigatório'),
    alerta: yup.string().when('flAlerta', {
      is: true,
      then: yup
        .string()
        .required('Opção de alerta selecionada mas nenhuma é inserida')
    }),
    cnpj: yup.string().required('informe um cnpj válido'),
    denuncia: yup.string().when('flDenuncia', {
      is: true,
      then: yup
        .string()
        .required('Opção de denúncia selecionada mas nenhuma é inserida')
    }),
    emailsTrabalhistas: yup
      .array()
      .min(1, 'Informe pelo menos um E-mail')
      .test('invalid', 'Informe pelo menos um E-mail', (emails) => {
        return emails.some((_, index) => !flExclusao[index])
      }),
    valorContratual: yup
      .number()
      .typeError('campo obrigatório')
      .required('O valor deve ser maior que R$ 0,00')
  })

  const {
    control,
    watch,
    handleSubmit,
    reset,
    setValue,
    clearErrors,
    setError,
    getFieldState,
    getValues,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const [isSuccess, toggleSucessModal] = useToggle()
  const [isError, toggleErrorModal] = useToggle()
  const { showModal } = useModal()
  const [messageError, setMessageError] = useState<string>('')
  const [, setFlagFornecedor] = useState<boolean>(false)

  const countObjetoPrincipal = contrato?.txObjetoContrato?.length || 0
  const inputChip = watch('emailsTrabalhistas')
  const dtInicioVigencia = watch('inicioVigencia')
  const dtInicioVigenciaReal = watch('fimVigenciaReal')
  const dtFimVigenciaReal = watch('inicioVigenciaReal')
  const countTextArea = watch('ObjetoDoContrato')
  const supplierCdDocto = watch('cnpj')
  const [, setFlSubcontrato] = useState(false)

  const [searchFile, setSearchFile] = useState<string>('')
  const [supplierName, setSupplierName] = useState<string>('')
  const [arquivosSelecionados, setArquivosSelecionados] = useState([])
  const [flagContrato, setFlagContrato] = useState<boolean>(false)
  const [flagSocio, setFlagSocio] = useState<boolean>(false)
  const [flagDenuncia, setFlagDenuncia] = useState<boolean>(false)
  const [flagAlerta, setFlagAlerta] = useState<boolean>(false)
  const [checkRecorrente, setCheckRecorrente] = useState<boolean>(false)
  const [flExclusao, setFlExclusao] = useState<boolean[]>([])

  const { website_url } = useEnvironment()

  const handleChangeInput = (value, field) => setValue(field, value)
  const inputTypingValue = useRef<string>('')

  const minDateFimVigencia = () => {
    if (contrato?.dtVigenciaFim < dtInicioVigencia) {
      return contrato?.dtVigenciaFim
    } else {
      return dtInicioVigencia
    }
  }

  const getSupplierByCnpj = (cnpj: string) => {
    if (cnpj.length > 0) {
      setLoading('loading')

      SupplierRegistrationServices()
        .getByCnpj(FORMAT.unMask(cnpj))
        .then(({ data }) => {
          setFlagFornecedor(false)

          //CHIPINPUT
          const emails = data.tFornecedorContatos?.map(
            (contatoFornecedor) => contatoFornecedor.txEmail
          )

          emails.map(() => setFlExclusao((prevState) => [...prevState, false]))

          handleChangeInput(emails, 'emailsTrabalhistas')
          handleChangeInput(data.idFornecedor, 'fornecedor')
          setSupplierName(data.nmFornecedor || '')
          setLoading('idle')
          setFlagFornecedor(true)
        })
        .catch((error) => {
          const axiosError = error as AxiosError

          setLoading('idle') //Colocado para sair do Loop Infinito - Thales 09/12

          setFlagFornecedor(false)
          handleChangeInput('', 'fornecedor')
          handleChangeInput([], 'emailsTrabalhistas')
          handleChangeInput('', 'cnpj')
          setSupplierName('')
          // setMsgErro(
          //   axiosError.response.data?.mensagem || 'Fornecedor não encontrado!'
          // )
          showModal({
            hideButtonCancel: true,
            message:
              axiosError.response.data?.mensagem ||
              'Fornecedor não encontrado!',
            txtButtonConfirm: 'Fechar',
            type: 'error'
          })
        })
    } else {
      handleChangeInput('', 'fornecedor')
      handleChangeInput(
        contrato.txEmails.map((email) => email.txEmail),
        'emailsTrabalhistas'
      )
      contrato.txEmails.map(() =>
        setFlExclusao((prevState) => [...prevState, false])
      )

      handleChangeInput('', 'cnpj')
      setSupplierName('')
    }
  }

  const handleDeleteFile = (fileName) => {
    let newArray = [...arquivosSelecionados]
    newArray = newArray.filter(
      (items) => items.dsExtensaoDoc !== fileName.dsExtensaoDoc
    )
    setArquivosSelecionados(newArray)
    handleChangeInput(newArray, 'uploads')
  }

  const handleFilterFilesTable = () => {
    if (searchFile !== '') {
      return arquivosSelecionados?.filter(
        (file) =>
          file?.dsDocumento?.toLowerCase().includes(searchFile.toLowerCase()) ||
          file?.dsExtensaoDoc?.toLowerCase().includes(searchFile.toLowerCase())
      )
    }

    return arquivosSelecionados
  }

  const handleChangeFile = async (files) => {
    if (files) {
      setLoading('loading')
      try {
        for (let i = 0; i < files.length; i++) {
          const newObj = {
            base64: await convertBase64(files[i]),
            dsDocumento: files[i].name,
            dsExtensaoDoc: files[i].type || 'application/octet-stream'
          }
          setArquivosSelecionados((prevState) => [...prevState, newObj])
        }
        setLoading('idle')
      } catch (err) {
        setLoading('error')
        setMsgErro('Não foi possível anexar o arquivo')
      }
    }
  }

  const getFilesToUpload = () => {
    return arquivosSelecionados.map((el) => {
      return {
        descricao: el.dsExtensaoDoc,
        anexoDocumentoId: 0,
        file: FORMAT.file(el.base64),
        nomeArquivo: el.dsDocumento,
        nuAnoMesCompetencia: parseInt(FORMAT.formatYYYYMM(new Date())),
        tipoPendenciaId: 13,
        tipoDocumentoId: 2,
        usuarioId: user.IdUsuario
      }
    })
  }

  const setUnidadeGestora = () => {
    const unidadeGestora = contrato?.nmUnidade
    const inputsDiretoria = [
      'diretoriaExecutiva',
      'diretoria',
      'gerenciaGeral',
      'gerencia'
    ]
    if (unidadeGestora) {
      const nomeUnidades = unidadeGestora.split('-')
      handleChangeInput(contrato?.unidadeGestoraId, 'idUnidadeGestora')

      for (let n = 0; n < inputsDiretoria.length; n++) {
        if (nomeUnidades[n]) {
          handleChangeInput(nomeUnidades[n], inputsDiretoria[n])
        } else {
          handleChangeInput('', inputsDiretoria[n])
        }
      }
    }
  }

  const setFormValue = () => {
    handleChangeInput(contrato?.idContrato, 'contratoPrincipalId')
    handleChangeInput(contrato?.cdContrato, 'cdContratoPrincipal')
    handleChangeInput(contrato?.cdGrupoMercadoria, 'codGrupoMercadoria')
    handleChangeInput(contrato?.cdHierarquiaProd, 'codHierarquiaProduto')
    handleChangeInput(contrato?.centroPlantaId, 'centroSelecionado')
    handleChangeInput(contrato?.centroCustoSapId, 'centroCustoSapId')
    handleChangeInput(contrato?.compradorUsuarioId, 'idComprador')
    handleChangeInput(contrato?.contraparteUsuarioId, 'idContraparte')
    handleChangeInput(contrato?.empresaId, 'empresa')
    handleChangeInput(contrato?.setorId, 'setor')
    handleChangeInput(contrato?.tipoCreId, 'tipoCreId')
    handleChangeInput(contrato?.txCno, 'cno')
    handleChangeInput(contrato?.unidadeGestoraId, 'unidadeGestoraId')
    handleChangeInput(contrato?.dtVigenciaFim, 'dataVigenciaContratoPrincipal')
    handleChangeInput(contrato?.txObjetoContrato, 'objetoContratoPrincipal')
    handleChangeInput(unidadeComprador, 'unidadeComprador')
    contrato.txEmails.map(() =>
      setFlExclusao((prevState) => [...prevState, false])
    )
  }

  const handleSubmitForm = (data) => {
    if (inputTypingValue.current) {
      setError('emailsTrabalhistas', {
        message:
          'Existem emails que foram preenchidos parcialmente, pressione espaço para finalizar o preenchimento!',
        type: 'custom'
      })
      return
    }

    setLoading('loading')

    const contraparteSubstituto = []

    contrato.contraparteSubstitutos?.forEach((value) => {
      if (value !== undefined) {
        contraparteSubstituto.push(value.usuarioId)
      }
    })

    const emailsToSend = [
      ...new Set(
        data?.emailsTrabalhistas.filter(
          (email: string, index) =>
            flExclusao[index] !== true && email.toLowerCase()
        )
      )
    ]

    const obj = {
      cdContrato: data.cdContratoPrincipal || '100',
      cdGrupoMercadoria: contrato?.cdGrupoMercadoria || '',
      centroPlantaId: data.centroSelecionado,
      compradorUsuarioId: contrato?.compradorUsuarioId || 0,
      contraparteUsuarioId: contrato?.contraparteUsuarioId || 0,
      contraparteUsuarioSubstitutoId: [1],
      contratoPrincipalId: parseInt(data.contratoPrincipalId) || 0,
      dtVigFimReal: moment(data.fimVigenciaReal).toDate() || null,
      dtVigInicoReal: moment(data.inicioVigenciaReal).toDate() || null,
      dtVigenciaFim: moment(data.fimVigencia).toDate(),
      dtVigenciaInicio: moment(data.inicioVigencia).toDate(),
      empresaId: data.empresa || 0,
      flAlerta: data.flAlerta || false,
      flDenuncia: data.flDenuncia || false,
      flEncerrado: data.flEncerrado || false,
      flRecorrente: data.flRecorrente || false,
      flSocio: data.Socio || false,
      flSubcontrato: data.flSubcontrato || false,
      fornecedorId: data.fornecedor || 0,
      hierarquiaId: contrato?.hierarquiaProdutoId || '',
      idUnidGestora: data.idUnidadeGestora || idUnidadeGestora || 0,
      itemProdutoId: contrato?.itemProdutoPrincipalId || 0,
      listContraparteSubstituto: contraparteSubstituto,
      setorContratoId: parseInt(data.setor) || 0,
      tipoCreId: data.tipoCreId || 0,
      txAlerta: data.alerta || null,
      txCno: data.cno || '',
      txDenuncia: data.denuncia || null,
      txEmail: emailsToSend || [],
      listAnexarDocs: getFilesToUpload() || null,
      txObjetoContrato: data.ObjetoDoContrato || '',
      txObservacao: data.observacao || '',
      url: website_url,
      vlContratual: data.valorContratual || 0
    }

    if (obj.flEncerrado && arquivosSelecionados.length <= 0) {
      showModal({
        hideButtonCancel: true,
        message: 'Por favor, anexe evidências que o contrato foi encerrado.',
        titleModal: 'Atenção',
        txtButtonConfirm: 'OK',
        type: 'alert'
      })
      setLoading('idle')
      return
    }

    ContractNGTServices()
      .create(obj)
      .then(() => {
        showModal({
          type: 'success',
          hideButtonCancel: true,
          titleModal: 'Sucesso',
          message: 'Subcontrato/quarteirização gerado com sucesso.',
          txtButtonConfirm: 'Fechar',
          handleConfirm() {
            handleCloseModal()
          }
        })
        setLoading('idle')
      })
      .catch(() => {
        setLoading('error')
        showModal({
          hideButtonCancel: true,
          titleModal: 'Alerta',
          message: 'Ocorreu um problema ao gerar o subcontrato/quarteirização.',
          txtButtonConfirm: 'Fechar',
          type: 'alert',
          handleConfirm() {
            handleCloseModal()
          }
        })
      })
  }
  const resetForm = () => {
    const defaultValues = {
      ObjetoDoContrato: '',
      Socio: false,
      alerta: '',
      cnpj: '',
      denuncia: '',
      emailsTrabalhistas: [],
      fimVigencia: dateNow,
      fimVigenciaReal: null,
      flAlerta: false,
      flDenuncia: false,
      flEncerrado: false,
      flRecorrente: false,
      inicioVigencia: dateNow,
      inicioVigenciaReal: null,
      observacao: '',
      tipoCreId: contrato?.tipoCreId,
      uploads: '',
      valorContratual: '0'
    }
    setFlSubcontrato(false)
    setSupplierName('')
    setArquivosSelecionados([])
    setCheckRecorrente(false)
    setFlagContrato(false)
    setFlagSocio(false)
    setFlagDenuncia(false)
    setFlagAlerta(false)
    reset(defaultValues)
    setFormValue()
    setUnidadeGestora()
  }

  useEffect(() => {
    setUnidadeGestora()
    setFormValue()
  }, [])

  return (
    <>
      <Form
        onSubmit={handleSubmit(handleSubmitForm)}
        marginLeft={SPACING.spacing20}
        onKeyDown={preventDefaultOnEnter}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <Row justifyContent="flex-end">
          <Button text="Fechar" onClick={handleCloseModal} />
        </Row>
        <SimpleCollapse title="INFORMAÇÕES GERAIS">
          <Row
            marginTop={SPACING.spacing10}
            marginBottom={SPACING.spacing20}
            justifyContent="space-between"
          >
            <Row marginTop={SPACING.spacing10}>
              <Span
                text="Data Cadastro:"
                fontSize={TYPOGRAPHY.bodySize16}
                fontWeight={FONTS.bold}
                marginRight={SPACING.spacing5}
              />
              <Span
                text={FORMAT.formatDDMMYYYY(new Date())}
                color={COLORS.blueFonts}
                fontSize={TYPOGRAPHY.bodySize16}
                fontWeight={FONTS.bold}
              />
            </Row>
          </Row>
          <Grid
            gridCols="1fr 4fr 3fr 3fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Input
              control={control}
              errors={errors}
              label="CPF/CNPJ/Cód.Fornecedor"
              placeholder="Nº"
              formValue="cnpj"
              mask={
                supplierCdDocto && supplierCdDocto.length > 9
                  ? ['###.###.###-##', '##.###.###/####-##']
                  : ['#########']
              }
              onBlur={(e) => getSupplierByCnpj(e.target.value)}
            />
            <Input
              value={supplierName}
              disabled
              label="Fornecedor"
              placeholder="Nome Fornecedor"
              formValue="nmFornecedor"
            />
            <Input
              disabled
              value={contrato?.nmEmpresa || null}
              label="Empresa"
              placeholder="Nº"
              formValue="empresa"
            />
            <Input
              disabled
              value={contrato?.nmCentro || null}
              label="Centro Planta"
              placeholder="Nº"
              formValue="centroSelecionado"
            // mask="cnpj"
            />
          </Grid>
          <Grid
            gridCols="4fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <TextArea
              required
              label="Objeto do contrato"
              control={control}
              errors={errors}
              formValue="ObjetoDoContrato"
              placeholder=""
              count={countTextArea?.length || 0}
              limitCount={150}
              maxLength={150}
            />
          </Grid>
          <Grid
            gridCols="3fr 3fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <AutoCompleteInput
              marginTop="0.25rem"
              control={control}
              errors={errors}
              defaultValue={contrato?.nmCRE}
              options={tipoCre}
              optionValue="txDenominacao"
              label="CRE"
              formValue="tipoCreId"
              valueName="idTipoCre"
            />
            <Input
              disabled
              value={contrato?.txCno || null}
              label="CNO (Cadastro Nacional de Obras)"
              placeholder="CNO"
              formValue="CNO"
              required
              min={0}
            />
          </Grid>
          <Grid
            gridCols="1fr 1fr 1fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          ></Grid>
          <Grid
            gridCols="1fr 1fr 1fr 1fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Picker
              defaultValue={dtVigenciaInicio ?? dateNow}
              label="Início Vigência Contrato"
              formValue="inicioVigencia"
              control={control}
            />
            <Picker
              minDate={dtVigenciaInicio ?? moment(minDateFimVigencia())}
              defaultValue={dtVigenciaFim}
              label="Fim Vigência Contrato"
              formValue="fimVigencia"
              control={control}
            />
            <Picker
              maxDate={dtVigenciaRealFim ?? moment(dtInicioVigenciaReal)}
              defaultValue={dtVigenciaRealInicio ?? null}
              label="Início Vigência Real"
              formValue="inicioVigenciaReal"
              control={control}
            />
            <Picker
              minDate={dtVigenciaRealInicio ?? moment(dtFimVigenciaReal)}
              defaultValue={dtVigenciaRealFim ?? null}
              label="Fim Vigência Real"
              formValue="fimVigenciaReal"
              control={control}
            />
          </Grid>
          <Grid
            gridCols="0.765fr 0.765fr 0.5fr 0.5fr 0.5fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <CurrencyInput
              defaultValue="0"
              control={control}
              errors={errors}
              label="Valor Contratual"
              formValue="valorContratual"
              placeholder="Valor"
              required
            />
            <Input
              disabled
              value={contrato?.nmSetor || null}
              label="Negócio"
              placeholder="Negócio"
              formValue="setor"
              required
              min={0}
            />
            <Col>
              <Span text="Tipo" />
              <CheckBox
                checked={checkRecorrente}
                label="Recorrente"
                onClick={(event) => {
                  handleChangeInput(event.target.checked, 'flRecorrente')
                  setCheckRecorrente((prevState) => !prevState)
                }}
              />
            </Col>
            <Col>
              <Span text="Contrato" />
              <CheckBox
                checked={flagContrato}
                label="Encerrado"
                onChange={(event) => {
                  handleChangeInput(event.target.checked, 'flEncerrado')
                  setFlagContrato((prevState) => !prevState)
                }}
              />
            </Col>
            <CheckBox
              marginTop="1rem"
              checked={flagSocio}
              label="Sócio"
              onChange={(event) => {
                handleChangeInput(event.target.checked, 'Socio')
                setFlagSocio((prevState) => !prevState)
              }}
            />
          </Grid>
          <Grid
            gridCols="0.8fr 0.8fr 2fr 2fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Col>
              <Span text="Notificação" />
              <CheckBox
                checked={flagDenuncia}
                label="Denúncia"
                onChange={(event) => {
                  handleChangeInput(event.target.checked, 'flDenuncia')
                  setFlagDenuncia((prevState) => !prevState)
                  if (!event.target.checked) {
                    handleChangeInput('', 'denuncia')
                  }
                }}
              />
            </Col>
            <CheckBox
              checked={flagAlerta}
              label="Alerta"
              onChange={(event) => {
                handleChangeInput(event.target.checked, 'flAlerta')
                setFlagAlerta((prevState) => !prevState)
                if (!event.target.checked) {
                  handleChangeInput('', 'alerta')
                }
              }}
            />
            <Input
              disabled={!flagDenuncia}
              control={control}
              errors={errors}
              label="Denúncia"
              placeholder="Justifique"
              formValue="denuncia"
              maxLength={300}
            />
            <Input
              maxLength={300}
              disabled={!flagAlerta}
              control={control}
              errors={errors}
              label="Alerta"
              placeholder="Justifique"
              formValue="alerta"
            />
          </Grid>
          <Grid
            gridCols="1.1fr 2fr 1fr 2.9fr 0.5fr 0.5fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Input
              value={contrato?.matriculaContraparte || null}
              disabled
              label="Matrícula Contraparte"
              placeholder="Nº"
              formValue="matriculaContraparte"
              required
              min={0}
            />
            <Input
              disabled
              value={contrato?.nmContraparte || null}
              label="Contraparte"
              formValue="nameContraparte"
              placeholder="Nome do Contraparte"
              required
            />
            <Input
              disabled
              value={
                contrato.ramalContraparte
                  ? contrato?.ramalContraparte?.trim()
                  : null
              }
              type="number"
              label="Ramal"
              formValue="ramalContraparte"
              placeholder="Nº"
              required
              min={0}
            />
            <Input
              disabled
              value={contrato?.emailContraparte || null}
              type="email"
              label="E-mail"
              formValue="emailContraparte"
              placeholder="Endereço de E-mail"
              required
            />
          </Grid>
          {contrato?.contraparteSubstitutos &&
            contrato?.contraparteSubstitutos?.length > 0 &&
            contrato?.contraparteSubstitutos?.map((contraparteSub) => {
              return (
                <Grid
                  key={contraparteSub?.usuarioId}
                  gridCols="1.1fr 2fr 1fr 2.9fr 0.5fr 0.5fr"
                  gridGap={`0 ${SPACING.spacing20}`}
                  margin={`0 0 ${SPACING.spacing30} 0`}
                >
                  <Input
                    value={contraparteSub?.matriculaContraparteSub || null}
                    disabled
                    label="Matrícula Contraparte Substituto"
                    placeholder="Nº"
                  />
                  <Input
                    disabled
                    value={contraparteSub?.nmContraparteSub || null}
                    label="Contraparte"
                    placeholder="Nome do Contraparte Substituto"
                  />
                  <Input
                    disabled
                    value={contraparteSub?.ramalContraparteSub || null}
                    label="Ramal"
                    placeholder="Nº"
                  />
                  <Input
                    disabled
                    value={contraparteSub?.emailContraparteSub || null}
                    label="E-mail"
                    placeholder="Endereço de E-mail"
                    required
                  />
                </Grid>
              )
            })}
          <Grid
            gridCols="1.1fr 2fr 1fr 2.9fr 1.1fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Input
              disabled
              value={
                contrato?.matriculaComprador ||
                selectedComprador?.nmMatricula ||
                null
              }
              label="Matrícula Comprador"
              placeholder="Nº"
              formValue="matriculaComprador"
              min={0}
            />
            <Input
              disabled
              value={
                contrato?.nmComprador ||
                selectedComprador?.usuario.nmUsuario ||
                null
              }
              label="Comprador"
              placeholder="Nome do Comprador"
              formValue="nameComprador"
            />
            <Input
              disabled
              value={
                contrato?.ramalComprador?.trim() ||
                selectedComprador?.usuario.nuRamal.trim() ||
                null
              }
              type="number"
              label="Ramal"
              placeholder="Nº"
              formValue="ramalComprador"
              min={0}
            />
            <Input
              disabled
              value={
                contrato?.emailComprador ||
                selectedComprador?.usuario.txEmail ||
                null
              }
              type="email"
              label="E-mail"
              placeholder="Endereço de E-mail"
              formValue="emailComprador"
            />
            <Input
              disabled
              type="number"
              value={unidadeComprador || null}
              label="Unidade do Comprador"
              placeholder="Unidade do Comprador"
              formValue="unidadeComprador"
              min={0}
            />
          </Grid>

          <UnidadeGestoraFields
            disabled
            gridCols={{
              Diretoria: 6,
              DiretoriaExecutiva: 6,
              Gerencia: 6,
              GerenciaGeral: 6,
              Unidade: 12,
              spacing: 1
            }}
            renderUnidadeSelect
            defaultValue={idUnidadeGestora}
          />

          <Grid
            gridCols="1fr 2fr 1fr 2fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`${SPACING.spacing30} 0 ${SPACING.spacing30} 0`}
          >
            <Input
              disabled
              value={contrato?.cdGrupoMercadoria}
              type="number"
              label="Cód. Grupo Mercadoria"
              placeholder="Cód."
              formValue="codGrupoMercadoria"
              required
              min={0}
            />
            <Input
              disabled
              label="Descrição do Grupo Mercadoria"
              placeholder="Descrição"
              value={contrato?.nmGrupoMercadoria}
              formValue="descGrupoMercadoria"
              required
            />
            <Input
              value={cdHierarquiaProd}
              disabled
              type="number"
              label="Cód. Hierarquia Produto"
              placeholder="Cód."
              required
              min={0}
            />
            <Input
              disabled
              label="Descrição Hierarquia Produto"
              placeholder="Descrição"
              value={contrato?.nmHierarquiaProduto}
              required
            />
          </Grid>
          <Grid
            gridCols="8fr "
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <ChipInput
              mensagem="Pressione espaço para selecionar um E-mail"
              errors={errors}
              control={control}
              onKeyUp={(event) => {
                const email = event?.target?.value?.trim(); // Mova esta linha para fora do bloco else
                if (event?.target?.value?.trim()) { // Verifique se há um email antes de prosseguir
                  const emailsTrabalhistas = getValues('emailsTrabalhistas');
                  const emailDuplicado = emailsTrabalhistas.includes(email);
                  setError('emailsTrabalhistas', {
                    message: 'E-mail não confirmado! Pressione ENTER caso queira incluí-lo.',
                    type: 'custom'
                  });
                  if (emailDuplicado) {
                    setError('emailsTrabalhistas', {
                      message: 'E-mail já cadastrado neste contrato, por favor, digite outro',
                      type: 'custom'
                    });
                  }
                  return;
                }
                clearErrors('emailsTrabalhistas');
              }}
              defaultValue={inputChip}
              enableInsertOnEnter
              formValue="emailsTrabalhistas"
              placeholder=""
              label="E-mail documentação trabalhista"
              only="email"
              flExclusao={flExclusao}
              setFlExclusao={setFlExclusao}
            />
            <Toast style={{ position: 'static', bottom: '1000px', left: '100px' }} message={toastMessage} show={showToast} />
          </Grid>
          <Grid
            gridCols="8fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing5} 0`}
          >
            <Input
              maxLength={1000}
              placeholder="insira uma observação se houver"
              control={control}
              label="Observação"
              formValue="observacao"
            />
          </Grid>
        </SimpleCollapse>
        <SimpleCollapse title="DADOS DO CONTRATO PRINCIPAL">
          <Grid
            gridCols="1fr 3.5fr 3.5fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
          >
            <Input
              label="Contrato"
              placeholder="Nº"
              value={contrato?.cdContrato || null}
              required
              min={0}
              disabled
            />
            <Input
              value={contrato?.nmFornecedor || null}
              label="Fornecedor"
              placeholder="Nome do Fornecedor"
              required
              disabled
            />

            <Input
              value={contrato?.txObservacao || null}
              disabled
              label="Observação"
              placeholder="Observação"
              formValue="observacaoPrincipal"
              required
            />
          </Grid>
          <Grid
            gridCols="2fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
          >
            <TextArea
              count={countObjetoPrincipal}
              disabled
              label="Objeto do contrato"
              control={control}
              errors={errors}
              formValue="objetoContratoPrincipal"
              placeholder=""
              limitCount={150}
              maxLength={150}
            />
          </Grid>
        </SimpleCollapse>
        <SimpleCollapse title="ANEXAR EVIDÊNCIAS">
          <Grid
            gridCols="3fr 1fr "
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
          >
            <InputFile
              renderInput={false}
              onChange={(files) => {
                const twoGigaBytes = 17179869184
                if (files[0].size >= twoGigaBytes) {
                  showModal({
                    hideButtonCancel: true,
                    message:
                      'O arquivo anexado não pode ter tamanho maior que 2GB',
                    titleModal: 'Atenção',
                    txtButtonConfirm: 'OK',
                    type: 'alert'
                  })
                  return
                }

                handleChangeFile(files)
                handleChangeInput(files, 'uploads')
              }}
              value={arquivosSelecionados}
              required
            />
            {arquivosSelecionados.length > 0 && (
              <Input
                value={searchFile}
                label="Pesquisa Geral"
                placeholder="Pesquisar"
                onChange={(e) => setSearchFile(e.target.value)}
                inputIcon={<SearchIcon />}
              />
            )}
          </Grid>
          <Grid gridCols="2fr " gridGap={`0 ${SPACING.spacing20}`}>
            {arquivosSelecionados.length > 0 && (
              <FakeAttachedFiles
                tableData={handleFilterFilesTable()}
                handleDeleteFile={handleDeleteFile}
              />
            )}
          </Grid>
        </SimpleCollapse>

        <Row justifyContent="flex-end" marginTop={SPACING.spacing20}>
          <Button
            text="Limpar"
            variantButton="text"
            onClick={() => resetForm()}
          />
          <Button
            text="Salvar e Finalizar"
            type="submit"
            marginLeft={SPACING.spacing20}
            disabled={inputChip && inputChip.length === 0}
          />
        </Row>
      </Form>
      <SuccessModal
        message="Dados de Contrato incluídos com sucesso"
        open={isSuccess}
        type="sucess"
        handleConfirm={() => {
          toggleSucessModal()
          handleCloseModal()
        }}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
      <SuccessModal
        message={messageError}
        open={isError}
        type="error"
        handleConfirm={toggleErrorModal}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
    </>
  )
}
